// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3cWRy","name":"Header_name__26l4a","birthday":"Header_birthday__23t4G","skeleton":"Header_skeleton__Z-FxR"};